import { Injectable, inject } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { firstValueFrom } from "rxjs";
import { environment } from "@env/environment";
import { ApiRoutes } from "app/core/constants/api-routes";
import {
  ServiceCancellationRequest,
  ServiceCancellationResponse,
} from "../models/service-cancel.model";

@Injectable({ providedIn: "root" })
export class ServiceCancelDataService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = environment.API_SERVICES;

  async cancelService(
    tenantId: string,
    request: ServiceCancellationRequest,
  ): Promise<ServiceCancellationResponse> {
    const url = `${this.baseUrl}${ApiRoutes.service.cancellation.submit(tenantId)}`;

    try {
      const response = await firstValueFrom(
        this.http.post<ServiceCancellationResponse>(url, request, {
          observe: "response",
        }),
      );

      if (response.status === 200 && response.body) {
        return {
          success: true,
          message:
            response.body.message || "Servicio anulado exitosamente",
        };
      }

      throw new Error("Unexpected response from server");
    } catch (error: any) {
      if (error?.status === 409) {
        throw Object.assign(
          new Error(
            error?.error?.message || "Service not allowed for cancellation",
          ),
          { code: 2, status: 409 },
        );
      }

      if (error?.status === 500) {
        throw new Error("Server error during service cancellation");
      }

      throw error;
    }
  }
}
